<template>
  <div
    id="relatorioDeSolicitacoesAnual"
    class="columns search buscar-solicitacoes no-print"
  >
    <div class="container container_com-fundo container_com-margem">
      <loading :ativo="loading.visivel" :mensagem="loading.mensagem" />
      <div class="columns search buscar-solicitacoes no-print">
        <form @submit.prevent class="formulario">
          <div class="grade__linha grade__linha_alinhar-vertical-a-base">
            <div class="grade__coluna grade__coluna_4">
              <label for="projeto">Projeto</label>
              <select
                id="projeto"
                name="projeto"
                v-model="projeto"
                @change="obterDadosDoProjeto"
              >
                <option v-for="projeto in projetos" :value="projeto.Id">
                  {{ projeto.Nome }}
                </option>
              </select>
            </div>

            <div class="grade__coluna grade__coluna_4">
              <label for="empreendimento">Empreendimento</label>
              <selectSearch
                id="empreendimento"
                v-model="empreendimento"
                :options="empreendimentos"
                placeholder="Selecione"
                selectLabel=""
                deselect-label=""
                label="Nome"
                :searchable="true"
                :allow-empty="true"
                :show-labels="false"
                :showNoResults="false"
                :disabled="deveDesabilitarFiltro"
              >
              </selectSearch>
            </div>

            <div class="grade__coluna grade__coluna_4">
              <label for="status">Situação</label>
              <vue-multi-select
                ref="multiSelect"
                id="status"
                v-model="status"
                :btnClass="btnClass"
                :btnLabel="btnLabel"
                :popoverClass="popoverClass"
                :options="options"
                :selectOptions="situacoes"
                :disabled="deveDesabilitarFiltro"
                emptyTabText="Carregando..."
              >
                <template slot="option" slot-scope="{ option }">
                  <div class="opcao-de-situacao">
                    <input
                      type="checkbox"
                      tabindex="-1"
                      class="opcao-de-situacao__checkbox"
                      :checked="option.selected"
                    />
                    <span :class="['tags']">{{
                      option.name
                    }}</span>
                  </div>
                </template>
              </vue-multi-select>
            </div>
          </div>
          <div class="grade__linha grade__linha_alinhar-vertical-a-base">
            <div class="grade__coluna grade__coluna_4">
              <label for="periodo">Período</label>
              <date-picker
                :range-separator="'  até  '"
                :format="'DD/MM/YYYY'"
                v-model="periodo"
                type="date"
                range
                placeholder="Selecione um período"
              ></date-picker>
            </div>
            <div class="grade__coluna grade__coluna_4">
              <label for="municipio">Município</label>
              <select
                id="cidade"
                name="cidade"
                v-model="cidade"
                @blur="obterEmpreendimentos"
                :disabled="deveDesabilitarFiltro"
              >
                <option v-for="cidade in cidades" :value="cidade.Id">
                  {{ cidade.Nome }}
                </option>
              </select>
            </div>

            <div class="grade__coluna grade__coluna_4">
              <label for="tipoDeRelatorio">Tipo de relatório</label>
              <div>
                <label for="visualizar" class="formulario__radio-container">
                  <input
                    name="radio"
                    type="radio"
                    value="visualizar"
                    v-model="selectedOption"
                    :disabled="deveEsconderTipoRelatorio"
                  />Visualizar lista para publicação
                </label>
              </div>
              <div>
                <label for="visualizar" class="formulario__radio-container">
                  <input
                    name="radio"
                    type="radio"
                    value="excel"
                    v-model="selectedOption"
                    :disabled="deveEsconderTipoRelatorio"
                  />Baixar lista para conferência
                </label>
              </div>
            </div>
          </div>
          <div class="grade__linha grade__linha_alinhar-vertical-a-base">
            <div class="grade__coluna grade__coluna_1">
              <button
                type="submit"
                class="botao botao_grande botao_cor-terciaria"
                @click="handleBotaoAcao"
                :disabled="!selectedOption"
              >
                {{ selectedOption === "excel" ? "Baixar" : "Filtrar" }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div
      class="container container_com-fundo container_com-margem"
      v-if="selectedOption === 'visualizar' && mostrarRelatorio"
    >
      <div class="grade__linha grade__linha_alinhar-vertical-a-base">
        <div
          class="grade__linha grade__linha_alinhar-horizontal-esquerda u-padding-pequena"
        >
          <p v-if="this.filtroSelecionado.projeto" class="texto texto_mini">
            Projeto:
            <span class="texto_cor-terciaria">{{ this.filtroSelecionado.projeto }}</span>
            /
          </p>
          <p v-if="this.filtroSelecionado.cidade" class="texto texto_mini">
            Cidade:
            <span class="texto_cor-terciaria">{{ this.filtroSelecionado.cidade }} /</span>
          </p>
          <p v-if="this.filtroSelecionado.empreendimento" class="texto texto__pequeno">
            Empreendimento:
            <span class="texto_cor-terciaria">
              {{ this.filtroSelecionado.empreendimento }}</span
            >
            /
          </p>
          <p v-if="this.filtroSelecionado.status" class="texto texto_mini">
            Situação:
            <span class="texto_cor-terciaria"> {{ this.filtroSelecionado.status }}</span>
            /
          </p>
          <p v-if="this.filtroSelecionado.data" class="texto texto_mini">
            Data:
            <span class="texto_cor-terciaria"> {{ this.filtroSelecionado.data }}</span>
            /
          </p>
          <p v-if="mostrarRelatorio" class="texto texto_mini">
            Tipo de relatório:
            <span class="texto_cor-terciaria"> Visualizar lista para publicação </span>
          </p>
        </div>
      </div>
      <div class="grade__linha grade__linha_alinhar-vertical-a-base">
        <div class="grade__coluna grade__coluna_10">
          <h2>{{ nomeDoRelatorio }}</h2>
        </div>
        <div class="grade__coluna grade__coluna_2">
          <button
            type="submit"
            class="botao botao_medio botao_contorno botao_largura-total botao_cor-terciaria"
            @click="gerarPdf"
            :disabled="
              !liberarBotao || (liberarBotao && informacoesParaRelatorio.length === 0)
            "
          >
            Gerar PDF
          </button>
        </div>
      </div>
      <loading :ativo="loading.visivel" :mensagem="loading.mensagem" />
      <div
        class="grade__linha informacoes-resultado-filtro no-print grade__linha_distribuir-horizontal-entre-elementos"
      >
        <div class="grade__coluna grade__coluna_9">
          <h4 class="titulo titulo_pequeno" v-if="informacoesParaRelatorio.length === 0">
            Nenhuma solicitação encontrada
          </h4>
        </div>
      </div>
      <table
        class="tabela tabela_listrada tabela_com-largura-total"
        v-if="informacoesParaRelatorio.length > 0"
      >
        <thead>
          <tr>
            <th>Ordem de Solicitação</th>
            <th v-if="deveExibirFaixaDeRenda">Faixa de Renda</th>
            <th>CPF</th>
            <th>Nome</th>
            <th>Município da solicitação</th>
            <th>Solicitado</th>
            <th>Reservado</th>
            <th>Subsídio</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="informacao of informacoesParaRelatorio"
            v-if="informacoesParaRelatorio.length > 0"
            :id="informacao.Id"
          >
            <td>
              <p>{{ informacao.Ordem }}</p>
            </td>

            <td v-if="deveExibirFaixaDeRenda">
              {{ informacao.FaixaDeRenda }}
            </td>
            <td>
              <div v-for="proponente in informacao.Proponentes">
                <p>{{ proponente.Cpf }}</p>
              </div>
            </td>
            <td>
              <div v-for="proponente in informacao.Proponentes">
                <p>{{ proponente.Nome }}</p>
              </div>
            </td>
            <td>
              {{ informacao.NomeDaCidade }}
            </td>
            <td>
              {{ informacao.DataDaSolicitacao ? informacao.DataDaSolicitacao : "---" }}
            </td>
            <td>
              {{ informacao.DataDaReserva ? informacao.DataDaReserva : "---" }}
            </td>
            <td>
              {{ exibirComoMoeda(informacao.ValorDoSubsidio) }}
            </td>
          </tr>
        </tbody>
      </table>

      <paginacao
        @paginar="mostrarRelatorioNaTela"
        :paginaAtual="paginaAtual"
        :totalDePaginas="totalDePaginas"
        :totalDeRegistros="totalDeRegistros"
      />
    </div>
  </div>
</template>

<script>
import Download from "../../utils/downloadDeArquivos.js";
import Alerta from "../shared/Alerta";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/locale/pt-br";
import "vue2-datepicker/index.css";
import vueMultiSelect from "vue-multi-select";
import "vue-multi-select/dist/lib/vue-multi-select.css";
import Loading from "../shared/Loading";
import selectSearch from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import Paginacao from "../shared/Paginacao";
import obterCorDoStatusDaSolicitacao from "../../utils/statusDaSolicitacao";

export default {
  name: "relatorioDeSolicitacoesAnual",
  components: {
    Alerta,
    DatePicker,
    vueMultiSelect,
    Loading,
    selectSearch,
    Paginacao,
  },
  data() {
    return {
      loading: { visivel: false },
      paginaAtual: 1,
      totalDePaginas: null,
      totalDeRegistros: null,
      mensagemDeAlerta: null,
      tipoDeAlerta: null,
      empreendimentos: [{ Id: null, Nome: "Selecione o empreendimento" }],
      empreendimento: null,
      projetos: [],
      projeto: null,
      cidades: this.cidades || [],
      cidade: null,
      periodo: [],
      status: [],
      btnLabel: (values) => `Situação selecionadas (${values.length})`,
      btnClass: "multi-select formulario__select",
      popoverClass: "itens",
      situacoes: [],
      options: {
        multi: true,
        groups: false,
        search: false,
        cssSelected: (option) =>
          option["selected"]
            ? { color: "rgb(148, 32, 0)", "font-weight": "bold !important" }
            : "",
      },
      selectedOption: "",
      mostrarRelatorio: false,
      informacoesParaRelatorio: [],
      liberarBotao: false,
      nomeDoRelatorio: "Relatório de solicitações por ano de exercício",
      filtroSelecionado: [
        { projeto: null },
        { status: null },
        { empreendimento: null },
        { cidade: null },
        { periodo: null },
      ],
      deveEsconderTipoRelatorio: false,
      deveDesabilitarFiltro: true,
      deveExibirFaixaDeRenda: false,
    };
  },
  created() {
    this.$api
      .get("/Projeto/ObterVigentes")
      .then((response) => {
        this.projetos = [{ Id: null, Nome: "Selecione o projeto" }];
        this.projetos = this.projetos.concat(response.data);

        return response;
      })
      .catch((error) => {
        console.error(error);
      });
  },
  methods: {
    obterEmpreendimentos() {
      this.$api
        .get("/Empreendimento/", { projetoId: this.projeto })
        .then((response) => {
          this.empreendimentos = [{ Id: null, Nome: "Selecione o empreendimento" }];
          this.empreendimentos = this.empreendimentos.concat(response.data);

          return response;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    gerarArquivoDoRelatorio(route) {
      let download = new Download();
      this.exibirCarregamento();
      const url = "/RelatorioDeSolicitacoes/";
      let urlComRota = `${url}${route}`;
      const projeto = this.projetos.find((projeto) => projeto.Id == this.projeto);
      const parametros = {
        projetoId: this.projeto,
        projetoNome: !projeto.Id ? "TODOS" : projeto.Nome,
        empreendimentoId: this.empreendimento && this.empreendimento.Id,
        empreendimentoNome: !this.empreendimento ? "TODOS" : this.empreendimento.Nome,
        cidadeId: this.cidade,
        status: this.status.map((s) => s.value),
        dataInicial: this.$tempo.formatarDatePickerParaApi(this.periodo[0]),
        dataFinal: this.$tempo.formatarDatePickerParaApi(this.periodo[1]),
      };
      download.realizarDownloadDeDocumentosComTratamentoDeErro(
        "POST",
        urlComRota,
        parametros,
        () => this.esconderCarregamento()
      );
    },
    exibirCarregamento(mensagem) {
      this.loading.visivel = true;
      this.loading.mensagem = mensagem;
    },
    exibirMensagemDeErro(mensagem) {
      this.tipoDeAlerta = "erro";
      this.mensagemDeAlerta = mensagem;
    },
    esconderCarregamento() {
      this.loading.visivel = false;
      this.mensagemDeAlerta = null;
    },
    handleBotaoAcao() {
      if (this.selectedOption === "excel") {
        let route = "ObterPorAnoDeExercicio";
        this.gerarArquivoDoRelatorio(route);
      } else {
        this.liberarBotao = true;
        this.mostrarRelatorioNaTela(1);
      }
    },
    mostrarRelatorioNaTela(pagina) {
      this.exibirCarregamento();
      const projeto = this.projetos.find((projeto) => projeto.Id == this.projeto);

      let parametros = {
        projetoId: this.projeto,
        projetoNome: !projeto.Id ? "TODOS" : projeto.Nome,
        empreendimentoId: this.empreendimento && this.empreendimento.Id,
        empreendimentoNome: !this.empreendimento ? "TODOS" : this.empreendimento.Nome,
        cidadeId: this.cidade,
        status: this.status.map((s) => s.value),
        dataInicial: this.$tempo.formatarDatePickerParaApi(this.periodo[0]),
        dataFinal: this.$tempo.formatarDatePickerParaApi(this.periodo[1]),
        pagina: pagina,
      };

      let statusSelecionado = this.status.map((s) => s.name).join(", ");
      let dataI = this.$tempo.formatarParaPadraoBrasileiro(this.periodo[0]);
      let dataF = this.$tempo.formatarParaPadraoBrasileiro(this.periodo[1]);
      let dataVazia = this.periodo[0] === undefined || this.periodo[1] === undefined;

      this.filtroSelecionado = {
        projeto: !projeto.Id ? "TODOS" : projeto.Nome,
        empreendimento: !this.empreendimento ? "TODOS" : this.empreendimento.Nome,
        status: statusSelecionado,
        data: dataVazia ? "" : dataI + " até " + dataF,
      };

      let url =
        projeto.Tipo === "McmvCidades"
          ? "/RelatorioDeSolicitacoes/FiltrarParaVisualizacaoMcmvCidades"
          : "/RelatorioDeSolicitacoes/FiltrarParaVisualizacaoBonusMoradia";
      this.deveExibirFaixaDeRenda = projeto.Tipo === "McmvCidades";
      this.$api
        .post(url, parametros)
        .then((response) => {
          const informacoesParaRelatorio = response.data.Modelo;
          this.informacoesParaRelatorio = informacoesParaRelatorio;
          this.paginaAtual = response.data.PaginaAtual;
          this.totalDePaginas = response.data.TotalDePaginas;
          this.totalDeRegistros = response.data.TotalDeRegistros;
          this.mostrarRelatorio = true;
          this.esconderCarregamento();
        })
        .catch((error) => {
          console.error(error);
          this.esconderCarregamento();
        });
    },
    exibirComoMoeda(valor) {
      return this.$moeda.formatar(valor);
    },
    gerarPdf() {
      const projeto = this.projetos.find((projeto) => projeto.Id == this.projeto);
      let route =
        projeto.Tipo === "McmvCidades"
          ? "ObterParaPublicacaoDoMcmvCidades"
          : "ObterParaPublicacaoDoBonusMoradia";
      this.gerarArquivoDoRelatorio(route);
      this.liberarBotao = false;
    },
    deveDesabilitarTipoDeRelatorio() {
      let projetoEscolhido = this.projeto;
      this.deveEsconderTipoRelatorio = projetoEscolhido === 1;
      let projetoEhFaixaUmEMeio = this.deveEsconderTipoRelatorio;

      if (projetoEhFaixaUmEMeio) {
        this.selectedOption = "excel";
      }
    },
    desabilitarFiltros() {
      this.deveDesabilitarFiltro = true;
    },
    habilitarFiltros() {
      this.deveDesabilitarFiltro = false;
    },
    obterDadosDoProjeto() {
      this.deveDesabilitarTipoDeRelatorio();
      this.desabilitarFiltros();

      this.status = [];
      this.situacoes = [];

      const projetoId = this.projeto;

      this.$api
        .get("/Projeto/ObterDados", { projetoId: projetoId })
        .then((response) => {
          if (projetoId !== this.projeto) return response;

          this.situacoes = response.data.Situacoes.map((s) => ({
            value: s.Id,
            name: s.Descricao,
            cor: obterCorDoStatusDaSolicitacao(s.Id),
          }));

          this.cidades = [{ Id: null, Nome: "Selecione a cidade" }];
          if (response.data.Cidades !== null)
            this.cidades = this.cidades.concat(response.data.Cidades);

          this.empreendimentos = [{ Id: null, Nome: "Selecione o empreendimento" }];
          if (response.data.Empreendimentos !== null)
            this.empreendimentos = this.empreendimentos.concat(
              response.data.Empreendimentos
            );

          this.habilitarFiltros();
          return response;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// GerarRelatorioDeSolicitacao.vue?69d83ca1